import { render, staticRenderFns } from "./property-form-preferences.vue?vue&type=template&id=739f7317&"
import script from "./property-form-preferences.vue?vue&type=script&lang=js&"
export * from "./property-form-preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports